// extracted by mini-css-extract-plugin
export default {"aliasList":"aliasList__style__sL_5p"};